import React from "react";
import HeaderSection from "../HeaderSection";
import Slider from "react-slick";
import styles from "./styles.module.scss";
import { dataClient, dataServer, dataOther } from "./data";

const Skills = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 10,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 5.5,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 4.5,
          initialSlide: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3.5,
          infinite: false,
        },
      },
    ],
  };
  var settingsOther = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 0,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  return (
    <>
      <HeaderSection title="Skills" id="skills"/>
      <div className={styles.client}>
        <h1>Client-Side:</h1>
      </div>
      <div className="slider-container slider-skills">
        <Slider {...settings}>
          {dataClient.map((el) => (
            <div className={styles.item} key={el.id}>
              <img src={el.link} alt={el.title} />
              <p>{el.title}</p>
            </div>
          ))}
        </Slider>
      </div>
      <div className={styles.client}>
        <h1>Server-Side:</h1>
      </div>
      <div className="slider-container slider-skills">
        <Slider {...settings}>
          {dataServer.map((el) => (
            <div className={styles.item} key={el.id}>
              <img src={el.link} alt={el.title} />
              <p>{el.title}</p>
            </div>
          ))}
        </Slider>
      </div>
      <div className={styles.client}>
        <h1>Other Services:</h1>
      </div>
      <div className="slider-container slider-skills slick-track-cus">
        <Slider {...settingsOther}>
          {dataOther.map((el) => (
            <div className={styles.item} key={el.id}>
              <img src={el.link} alt={el.title} />
              <p>{el.title}</p>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Skills;
